module.exports = __webpack_public_path__ + "static/media/ic-car.d8b673c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-car.svg
// module id = 605
// module chunks = 14